export let TpaPageId = /*#__PURE__*/function (TpaPageId) {
  TpaPageId["ThankYou"] = "Thank You";
  TpaPageId["Paywall"] = "Paywall";
  TpaPageId["PackagePicker"] = "membership_plan_picker_tpa";
  TpaPageId["Checkout"] = "Checkout";
  TpaPageId["PlanCustomization"] = "Plan Customization";
  return TpaPageId;
}({});

/**
 * Trimmed integration data that will be supported in query based routing. It skips internal navigation options and does
 * not need restricted page ID.
 */

/**
 * Partial status data skips everything that can be computed from orderId. This is intermediate data structure that will
 * be transformed to StatusData in the router.
 */

/**
 * Partial checkout data allows only planId. This is intermediate data structure that will be transformed to
 * CheckoutData in the router.
 */
//# sourceMappingURL=types.js.map